// extracted by mini-css-extract-plugin
export default {"fullScreenLoader":"LoadingSpinner_fullScreenLoader__ie637","spinner":"LoadingSpinner_spinner__Q1vlO"};